import React from "react";
// ? Redux
import { useSelector } from "react-redux";
// ? Style
import styled from "styled-components";
import { motion } from "framer-motion";
// ? Utils
import { smallImage } from "../util";
// ? Images
import playstation from "../img/playstation.svg";
import steam from "../img/steam.svg";
import xbox from "../img/xbox.svg";
import nintendo from "../img/nintendo.svg";
import apple from "../img/apple.svg";
import gamepad from "../img/gamepad.svg";
import starEmpty from "../img/star-empty.png";
import starFull from "../img/star-full.png";
// ? Components
import { CircularProgress } from "@material-ui/core";
import { Container, Row, Col } from "react-bootstrap";

const GameDetail = () => {
  const { game, screenshots, isLoading } = useSelector(
    (state) => state.gameDetail
  );

  // ? Get paltform images
  const getPlatform = (platform) => {
    switch (platform) {
      case "PlayStation 5":
        return playstation;
      case "PlayStation 4":
        return playstation;
      case "Xbox One":
        return xbox;
      case "Xbox Series S/X":
        return xbox;
      case "PC":
        return steam;
      case "Nintendo Switch":
        return nintendo;
      case "iOS":
        return apple;
      default:
        return gamepad;
    }
  };

  // ? Get stars
  const getStars = () => {
    const stars = [];
    const rating = Math.floor(game.rating);
    for (let i = 1; i <= 5; i++) {
      if (i <= rating) {
        stars.push(<img alt="star" key={i} src={starFull} />);
      } else {
        stars.push(<img alt="star" key={i} src={starEmpty} />);
      }
    }
    return stars;
  };

  return (
    <>
      {isLoading && (
        <Loader>
          <CircularProgress color="inherit" size="8rem" />
        </Loader>
      )}
      {!isLoading && (
        <Main>
          <Container>
            <Detail>
              <Stats>
                <div className="rating">
                  <h3>{game.name}</h3>
                  <p>Rating: {game.rating}</p>
                  {getStars()}
                </div>

                <Info>
                  <h3>Platforms</h3>
                  <Platforms>
                    {game.platforms.map((data) => (
                      <img
                        className="paltform"
                        key={data.platform.id}
                        src={getPlatform(data.platform.name)}
                        alt={data.platform.name}
                      />
                    ))}
                  </Platforms>
                </Info>
              </Stats>

              <Media>
                {game.background_image && (
                  <img
                    src={smallImage(game.background_image, 1280)}
                    alt={game.name}
                  />
                )}
              </Media>

              <Container className="my-5">
                <Description>
                  <p>{game.description_raw}</p>
                </Description>
              </Container>

              <div className="gallery">
                {screenshots.results.map((screen) => (
                  <img
                    src={smallImage(screen.image, 1280)}
                    alt={game.name}
                    key={screen.id}
                  />
                ))}
              </div>
            </Detail>
          </Container>
        </Main>
      )}
    </>
  );
};

const Main = styled(motion.div)`
  width: 100%;
`;

const Detail = styled(motion.div)`
  border-radius: 1rem;
  background-color: rgba(42, 42, 42, 1);
  color: black;
  img {
    width: 100%;
  }
  @media screen and (max-width: 786px) {
    h3 {
      font-size: 1.5rem;
    }
    p {
      font-size: 0.9rem;
    }
    .rating {
      img {
        width: 20px;
        height: 20px;
      }
    }
    .paltform {
      width: 20px;
      height: 20px;
    }
  }
`;

const Stats = styled(motion.div)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  img {
    width: 2rem;
    height: 2rem;
    display: inline;
  }
`;

const Info = styled(motion.div)`
  text-align: center;
`;

const Platforms = styled(motion.div)`
  display: flex;
  justify-content: space-evenly;
  img {
    margin-left: 3rem;
  }
  @media screen and (max-width: 786px) {
    img {
      margin-left: 1rem;
    }
  }
`;

const Media = styled(motion.div)`
  margin-top: 5rem;
  img {
    width: 100%;
  }
`;

const Description = styled(motion.div)``;

const Loader = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
`;
export default GameDetail;
